import { createRoute } from '@tanstack/react-router';
import { ZakazniciSpravaPage } from '@/modules/zakaznici/sprava/ZakazniciSpravaPage';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/zakaznici/sprava',
  component: ZakazniciSpravaPage,
});
